import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, BookOpenIcon, ShoppingBagIcon } from '@heroicons/react/24/outline';

const Marketplace = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: 'content',
      title: 'Content',
      description: 'Purchase specialized content tracks for your disciples',
      icon: BookOpenIcon,
      color: 'blue',
      items: [
        {
          id: 'free',
          title: 'Free Content Tracks',
          description: 'Access our free library of discipleship content',
          price: 'FREE',
          featured: true,
        },
        {
          id: 'premium',
          title: 'Premium Content Tracks',
          description: 'Specialized content tracks available for purchase',
          price: 'Coming Soon',
          featured: false,
        },
      ],
    },
    {
      id: 'swag',
      title: 'Swag',
      description: 'Get Together On Mission gear',
      icon: ShoppingBagIcon,
      color: 'green',
      items: [
        {
          id: 'tshirt',
          title: 'T-Shirts',
          description: 'Comfortable cotton t-shirts',
          price: 'Coming Soon',
          featured: false,
        },
        {
          id: 'mug',
          title: 'Mugs',
          description: 'Keep your coffee warm with our mugs',
          price: 'Coming Soon',
          featured: false,
        },
        {
          id: 'hat',
          title: 'Hats',
          description: 'Stylish caps and beanies',
          price: 'Coming Soon',
          featured: false,
        },
        {
          id: 'hoodie',
          title: 'Hoodies',
          description: 'Cozy hooded sweatshirts',
          price: 'Coming Soon',
          featured: false,
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-green-500 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate(-1)}
              className="p-2 hover:bg-white/20 rounded-lg transition-colors"
            >
              <ArrowLeftIcon className="h-6 w-6" />
            </button>
            <h1 className="text-2xl sm:text-3xl font-bold">Marketplace</h1>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* Intro Section */}
        <div className="mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
            Welcome to the Marketplace
          </h2>
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
            Discover content tracks for your disciples and Together On Mission gear.
          </p>
        </div>

        {/* Categories */}
        <div className="space-y-8 sm:space-y-12">
          {categories.map((category) => {
            const IconComponent = category.icon;
            return (
              <div key={category.id} className="bg-white rounded-lg shadow-sm p-4 sm:p-6 lg:p-8">
                {/* Category Header */}
                <div className="flex items-start gap-4 mb-6">
                  <div className={`p-3 rounded-full bg-${category.color}-100 flex-shrink-0`}>
                    <IconComponent className={`h-6 w-6 text-${category.color}-600`} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
                      {category.title}
                    </h3>
                    <p className="text-sm sm:text-base text-gray-600">
                      {category.description}
                    </p>
                  </div>
                </div>

                {/* Items Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                  {category.items.map((item) => (
                    <div
                      key={item.id}
                      className={`border-2 rounded-lg p-4 sm:p-6 transition-all duration-200 ${
                        item.featured
                          ? 'border-blue-500 bg-blue-50 hover:shadow-lg'
                          : 'border-gray-200 bg-white hover:shadow-md'
                      } ${item.price === 'Coming Soon' ? 'opacity-75' : 'cursor-pointer'}`}
                    >
                      <div className="flex items-start justify-between mb-3">
                        <h4 className="text-lg font-semibold text-gray-900 flex-1 pr-2">
                          {item.title}
                        </h4>
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
                            item.price === 'FREE'
                              ? 'bg-green-100 text-green-700'
                              : item.price === 'Coming Soon'
                              ? 'bg-gray-100 text-gray-600'
                              : 'bg-blue-100 text-blue-700'
                          }`}
                        >
                          {item.price}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600 mb-4">{item.description}</p>
                      {item.price === 'Coming Soon' && (
                        <div className="text-xs text-gray-500 italic">
                          Available Soon
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Marketplace;
